import React from 'react';
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { COLORS } from './Colors.js'
import { Line, Header } from './Elements.js'

const Welcome = () => {

  const { lang } = useParams();
  const { t, i18n } = useTranslation();

  // Change the language dynamically
  React.useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang, i18n]);

  const currentPage = 'welcome'

  //creating an array that contains all the sections of the welcome page
  const sections = t(currentPage, { returnObjects: true })
  const sectionKeys = Object.keys(sections);

  // creating a colorMap by matching sections to colors
  const colourMap = sectionKeys.reduce((map, section, index) => {
    map[section] = COLORS[index % COLORS.length]; // Handle cases where there are more sections than colors
    return map;
  }, {});

  return (
    <div>
      {sectionKeys.map((section, i) => {
        const sectionContent = sections[section]
        const sectionColor = colourMap[section]

        if (i === 0) {
          return <Header
            key="0"
            sectionKey={section}
            sectionContent={sectionContent}
            sectionColor={sectionColor}
          />
        }

        return <Line
          key={i}
          sectionKey={section}
          sectionContent={sectionContent}
          sectionColor={sectionColor}
          alignLeft={(i % 2 === 0)}
        />
      })}
    </div>
  );
};

export default Welcome;